
import Footer from '../../../../../components/Footer/Footer';
import InnerNav from '../../../../../components/InnerNav/InnerNav';
import './Madhya.scss';

const Madhya = () => {
  const data = {
    bhavHeaders: [
      { house: 1, degree: 167, aspect: 59 },
      { house: 2, degree: 197, aspect: 58 },
      { house: 3, degree: 227, aspect: 57 },
      { house: 4, degree: 257, aspect: 57 },
      { house: 5, degree: 287, aspect: 57 },
      { house: 6, degree: 317, aspect: 58 },
      { house: 7, degree: 347, aspect: 59 },
      { house: 8, degree: 17, aspect: 58 },
      { house: 9, degree: 47, aspect: 57 },
      { house: 10, degree: 77, aspect: 57 },
      { house: 11, degree: 107, aspect: 57 },
      { house: 12, degree: 137, aspect: 58 },
    ],
    aspectData: [
      { planet: "SUN", degree: "90.41", aspects: { 4: "OPPN\n1.51" } },
      { planet: "MOON", degree: "350.7", aspects: {} },
      { planet: "MARS", degree: "143.7", aspects: { 3: "SEXT\n0.42", 4: "SQUR\n0.42", 5: "TRIN\n0.41", 7: "OPPN\n6.56" } },
      { planet: "MERC", degree: "111.19", aspects: { 2: "SEXT\n1.33", 3: "SQUR\n1.32", 4: "TRIN\n1.32", 6: "OPPN\n7.76" } },
      { planet: "JUPT", degree: "74.13", aspects: { 1: "SQUR\n1.12", 2: "TRIN\n1.13", 4: "OPPN\n7.51", 10: "CONJ\n7.51", 12: "SEXT\n1.13" } },
      { planet: "VENU", degree: "49.50", aspects: { 1: "TRIN\n2.07", 3: "OPPN\n8.75", 11: "SEXT\n2.06", 12: "SQUR\n2.07" } },
      { planet: "SATN", degree: "337.41", aspects: { 7: "CONJ\n3.14" } },
      { planet: "RAHU", degree: "326.50", aspects: {} },
      { planet: "KETU", degree: "146.50", aspects: { 4: "OPPN\n4.09" } },
      { planet: "URAN", degree: "36.14", aspects: { 3: "OPPN\n2.19", 6: "CONJ\n2.19", 11: "QUIN\n0.72" } },
      { planet: "NEPT", degree: "337.51", aspects: { 7: "CONJ\n3.25" } },
      { planet: "PLUT", degree: "278.21", aspects: { 4: "CONJ\n3.59", 5: "NONL\n0.62" } },
    ],
  };

  return (
    <div className="aspect-bhav-wrapper">
        <InnerNav/>
      <h2>Aspect On Bhav Madhya</h2>
      <div className="table-scroll">
        <table className="aspect-table">
          <thead>
            <tr className="header-top">
              <th></th>
              {data.bhavHeaders.map((item) => (
                <th key={`house-${item.house}`}>{item.house}</th>
              ))}
            </tr>
            <tr className="header-sub">
              <th></th>
              {data.bhavHeaders.map((item) => (
                <th key={`deg-${item.house}`}>{item.degree}</th>
              ))}
            </tr>
            <tr className="header-sub">
              <th></th>
              {data.bhavHeaders.map((item) => (
                <th key={`asp-${item.house}`}>{item.aspect}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.aspectData.map((planet) => (
              <tr key={planet.planet}>
                <td className="planet-name">
                  <strong>{planet.planet}</strong>
                  <div className="degree">{planet.degree}</div>
                </td>
                {data.bhavHeaders.map((bhav) => (
                  <td key={`${planet.planet}-${bhav.house}`}>
                    {planet.aspects[bhav.house] ? (
                      planet.aspects[bhav.house].split('\n').map((line, i) => (
                        <div key={i}>{line}</div>
                      ))
                    ) : (
                      <span className="dash">--</span>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Footer/>
    </div>
  );
};

export default Madhya;
